export const scriptMappingColumns: any = [
    {
      key: 'expand',
      showExpand: true,
      fixedLeft: true,
      width: '36px',
      headerStyles: {
        background: "#7593F2",
        width: '36px'
      }
    },
    {
      display_name: "Test Suite ID",
      key: "versionName",
      hideForChildren: true,
      fixedLeft: true,
      width: '130px',
      headerStyles: {
        background: "#7593F2",
        width: '130px'
      }
    },
    // {
    //   display_name: "Test Case ID",
    //   key: "testCaseId",
    //   headerStyles: {
    //     background: "#7593F2"
    //   }
    // },
    // {
    //   display_name: "Test Steps",
    //   key: "testScenario",
    //   headerStyles: {
    //     background: "#7593F2",
    //     width: '40%'
    //   }
    // },
    // {
    //   display_name: "Story ID",
    //   key: "key",
    //   headerStyles: {
    //     background: "#7593F2",
    //     color: "#FFFFFF",
    //     width: "10%",
    //     "font-weight": 600,
    //   },
    // },
    // {
    //   display_name: "Story",
    //   key: "storydesc",
    //   headerStyles: {
    //     background: "#7593F2",
    //     color: "#FFFFFF",
    //     "font-weight": 600,
    //     width: "10%",
    //   },
    // },
    {
      display_name: "TC ID",
      key: "testCaseId",
      fixedLeft: true,
      width: '160px',
      headerStyles: {
        background: "#7593F2",
        color: "#FFFFFF",
        width: "160px",
        "font-weight": 600,
      },
    },
    {
      display_name: "TC Description",
      key: "testCase",
      width: '220px',
      headerStyles: {
        background: "#7593F2",
        color: "#FFFFFF",
        "font-weight": 600,
        width: "220px",
      },
    },
    {
      display_name: "Prerequisites",
      key: "prerequisites",
      type: "orderd-list",
      width: '220px',
      headerStyles: {
        background: "#7593F2",
        color: "#FFFFFF",
        "font-weight": 600,
        width: "220px",
      },
    },
    {
      display_name: "Test Steps",
      key: "testScenario",
      type: "orderd-list",
      width: '320px',
      headerStyles: {
        background: "#7593F2",
        color: "#FFFFFF",
        "font-weight": 600,
        width: "320px",
      },
    },
    {
      display_name: "Expected Results",
      key: "expectedResult",
      type: "orderd-list",
      width: '280px',
      headerStyles: {
        background: "#7593F2",
        color: "#FFFFFF",
        "font-weight": 600,
        width: "280px",
      },
    },
    {
      display_name: "Action",
      key: "map",
      fixedRight: true,
      width: '110px',
      _config: {
        type: 'conditional-button',
        name: 'Map',
        classNames: 'btn-accello-secondary open-btn ',
        isConditionalCheck: true,
        conditionalCheck : { key: "versionName"},
      },
      headerStyles: {
        background: "#7593F2",
        color: "#FFFFFF",
        "font-weight": 600,
        width: '110px'
      }
    }
    // {
    //   display_name: "",
    //   key: "map",
    //   _config: {
    //     type: 'button',
    //     name: 'Map',
    //     classNames: 'btn-accello-primary open-btn'
    //   },
    //   headerStyles: {
    //     background: "#7593F2",
    //     width: '15%'
    //   }
    // }
  ];


// export const scriptMappingColumns: any = [
//   {
//     key: 'expand',
//     showExpand: true,
//     headerStyles: {
//       background: "#7593F2",
//       width: '30px'
//     }
//   },
//   {
//     display_name: "Test Suit ID",
//     key: "testSuitId",
//     hideForChildren: true,
//     headerStyles: {
//       background: "#7593F2",
//       width: '40%'
//     }
//   },
//   {
//     display_name: "Test Case ID",
//     key: "testCaseId",
//     _config: {
//       type: 'select',
//       options: [
//         {
//           label: 'ABC',
//           value: 'abc'
//         }
//       ]
//     },
//     headerStyles: {
//       background: "#7593F2"
//     }
//   },
//   {
//     display_name: "Test Case Description",
//     key: "testCaseDescription",
//     _config: {
//       type: 'section_dropdown',
//       targetKey: 'browser',
//       componentInputs: {
//         config: {
//           placeholderText: 'Add Global Browser',
//           placeholderIcon: 'language',
//           iconType: 'assetImage'
//         },
//         fields: [
//           {
//             "label":"Section test",
//             "options":[
//               {
//               "label":"Chrome",
//               "icon":"assets/images/agent/agent-alive.svg",
//               "value":"2"
//               },
//               {
//                 "label":"Edge",
//                 "icon":"assets/images/agent/agent-dead.svg",
//                 "value":"3"
//               },
//               {
//                 "label":"Mozhila Firefox",
//                 "icon":"assets/images/agent/agent-alive.svg",
//                 "value":"4"
//               },
//               {
//                 "label":"Operamini",
//                 "icon":"assets/images/agent/agent-alive.svg",
//                 "value":"1"
//               }
//             ]
//           }
//         ]
//       }
//     },
//     headerStyles: {
//       background: "#7593F2",
//       width: '20%'
//     }
//   },
//   {
//     display_name: "",
//     key: "map",
//     _config: {
//       type: 'button',
//       name: 'Map',
//       classNames: 'btn-accello-primary open-btn'
//     },
//     headerStyles: {
//       background: "#7593F2",
//       width: '15%'
//     }
//   }
// ];